module.exports = __webpack_public_path__ + "img/16-windsurf-board-with-a-sail-min.8bd98202.png";